const config = () => {
  return {
    defaultCitySlug: 'spb',
    defaultCity: {
      id: "5bc0869a-f509-11eb-ac3a-005056856341",
      latitude: 59.80106,
      longitude: 30.394938,
      name: "Санкт-Петербург",
      slug: "spb"
    },
    manageUrl: import.meta.env.VITE_MANAGE_URL,
    apiBaseUrl: import.meta.env.VITE_BACKEND_URL
  }
}

export default config;
